import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    capitalize: {
        "& input": {
            textTransform: "capitalize",
        },
    },
    uppercase: {
        "& input": {
            textTransform: "uppercase",
        },
    },
    lowercase: {
        "& input": {
            textTransform: "lowercase",
        },
    },
}));

export default useStyles;
